import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'text',
        name: 'accountCode',
        title: i18n.t('account.form.accountCode'),
        rules: {required: true},
        modal: ['account_no'],
        data: ['account_info', 'account', 'account_no'],
        additionalButton: {
            icon: 'arrow-repeat',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('account.form.newAccountNo'),
            type: 'newAccount'
        },
        checkBox: false
    },
    {
        type: 'text',
        name: 'part',
        title: i18n.t('account.form.part'),
        rules: {required: true, numeric: true},
        modal: ['part_no'],
        data: ['PartNo'],
        additionalButton: false,
        checkBox: {
            name: 'is_part',
            modal: ['is_part'],
            data: ['account_info','account','is_part'  ],
        }
    },
    {
        type: 'text',
        name: 'name',
        title: i18n.t('account.form.name'),
        rules: {required: true},
        modal: ['name'],
        data: ['name'],
        additionalButton: false,
        checkBox: false
    },
    {
        type: 'select',
        name: 'accountType',
        title: i18n.t('account.form.type'),
        rules: {required: true},
        modal: ['account_type'],
        data: ['account_type'],
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'job',
        title: i18n.t('account.form.job'),
        rules: {required: true},
        modal: ['job_ID'],
        data: ['job'],
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'address',
        title: i18n.t('account.form.address'),
        rules: {required: true},
        modal: ['address_id'],
        data: ['address'],
        options: {
            data: [],
            label: 'name',
            track: 'ID'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Customer',
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'brand',
        nextField: 'model',
        title: i18n.t('account.form.brand'),
        rules: {required: true},
        modal: ['brand_id'],
        data: ['account_info', 'account', 'panel_brand'],
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'model',
        title: i18n.t('account.form.model'),
        beforeField: 'brand',
        rules: {required: true},
        modal: ['model_id'],
        data: ['account_info', 'account', 'panel_model'],
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'select',
        name: 'signalProtocol',
        title: i18n.t('account.form.protocol'),
        rules: {required: true},
        modal: ['protocol_id'],
        data: ['account_info', 'account', 'signal_protocol'],
        options: {
            data: [],
            label: 'name',
            track: 'id'
        },
        additionalButton: {
            icon: 'plus',
            variant: 'primary',
            size: 'sm',
            title: i18n.t('general.add'),
            type: 'Defination',
        },
        checkBox: false
    },
    {
        type: 'text',
        name: 'branch_code',
        title: i18n.t('account.form.branchCode'),
        data: ['branch_code'],
        rules: {required: false},
        modal: ['branch_code'],
        additionalButton: false,
        checkBox: false
    },
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/Alarmsis/Account/forms/generalForms.js